import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Collapse,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface PersonCardProps {
  name: string;
  role: string;
  image: string;
  imageAlt?: string;
  description: string;
  grayscale?: boolean;
  // index: number;
  // setRef: (el: HTMLDivElement | null, index: number) => void;
  // maxHeight: number;
  fixedHeight: number;
  isMobile: boolean;
}

const PersonCard: React.FC<PersonCardProps> = ({
  name,
  role,
  image,
  imageAlt,
  description,
  grayscale = false,
  fixedHeight,
  // index,
  // setRef,
  // maxHeight,
  isMobile,
}) => {
  const [expanded, setExpanded] = useState(false);
  //const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        boxShadow: "none",
        borderRadius: 0,
        cursor: "pointer",
        overflow: "hidden",
        p: 0,
        display: "flex",
        flexDirection: "column",
      }}
      onClick={() => setExpanded((s) => !s)}
    >
      {/* Imagen */}
      <Box sx={{ position: "relative", height: 440, overflow: "hidden" }}>
        <CardMedia
          component="img"
          image={image}
          alt={imageAlt}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: grayscale ? "grayscale(100%)" : "none",
            transition: "transform 0.3s ease, filter 0.3s ease",
            "&:hover": {
              filter: "none",
              transform: "scale(1.02)",
            },
          }}
        />
      </Box>

      {/* Info básica (siempre visible) */}
      <CardContent
        sx={{
          textAlign: "center",
          flexShrink: 0,
          height: { xs: 90, sm: 110, md: 100, lg: 95 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {name}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {role}
        </Typography>
      </CardContent>

      {/* Bio expandible */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {/* Info básica debajo de la foto */}
        <Box sx={{ px: 2, py: 2 }} onClick={(e) => e.stopPropagation()}>
          <Box
            // ref={(el) => setRef(el as HTMLDivElement | null, index)}
            sx={{
              //height: { xs: 350, sm: 220, md: 235, lg: 320 },
              // minHeight: isMobile ? "auto" : maxHeight || "auto", // todas iguales en desktop
              height: isMobile ? "auto" : fixedHeight,
              overflowY: "visible",
              pr: 1,
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.6,
                textAlign: "justify",
                whiteSpace: "pre-line",
                wordSpacing: {
                  xs: "normal",
                  sm: "normal",
                  md: "0.12em",
                  lg: "0.12em",
                },
              }}
            >
              {description}
            </Typography>
          </Box>
        </Box>
      </Collapse>
    </Card>
  );
};

export default PersonCard;
